import React from 'react';

// Páginas públicas /terminos, /privacidad, /reembolsos y /eliminar-cuenta (sin cuenta). Al cambiar el texto,
// sube VERSION_LEGAL: el registro guarda qué versión aceptó cada usuario.
export const VERSION_LEGAL = '2026-10-08';
const FECHA = '8 de octubre de 2026';
const CONTACTO = 'automatika.ia@gmail.com';

const TERMINOS = [
  ['1. Quiénes somos', [
    'Kontrol es una plataforma en línea para administrar negocios (inventario, ventas, clientes, servicios, citas, reportes y catálogo digital). Kontrol es un producto de Automatika.ia, con domicilio en Olanchito, Yoro, Honduras ("Automatika.ia" o "nosotros").',
    `Para cualquier consulta puedes escribirnos a ${CONTACTO}.`,
  ]],
  ['2. Aceptación', [
    'Al crear una cuenta o usar Kontrol aceptas estos Términos y nuestra Política de Privacidad. Si no estás de acuerdo, no uses la plataforma.',
  ]],
  ['3. Solo para mayores de 18 años', [
    'Kontrol es una herramienta para negocios y solo puede usarla una persona mayor de 18 años con capacidad legal para contratar. Al registrarte confirmas que cumples este requisito.',
    'Si nos enteramos de que una cuenta pertenece a un menor de edad, podemos suspenderla y eliminar sus datos.',
  ]],
  ['4. Tu cuenta', [
    'Eres responsable de que los datos de registro sean ciertos, de cuidar tu contraseña y de todo lo que se haga desde tu cuenta, incluyendo a los usuarios que invites a tu negocio.',
    'Avísanos de inmediato si crees que alguien entró a tu cuenta sin permiso.',
  ]],
  ['5. Prueba gratis, planes y pagos', [
    'Las cuentas nuevas tienen una prueba gratis de 14 días. Al terminar, puedes contratar un plan (mensual o anual) según los precios publicados dentro de la app en "Mi plan".',
    'Los pagos son por adelantado y cubren el período contratado. Puedes pagar con tarjeta (el plan se renueva automáticamente cada mes o cada año hasta que lo canceles) o por transferencia coordinada con nosotros; en ese caso la cuenta se activa al confirmar el pago.',
    'Podemos cambiar los precios avisándote con al menos 30 días de anticipación; el cambio aplica desde tu siguiente período.',
    'Las cancelaciones y los reembolsos se rigen por nuestra Política de Cancelación y Reembolsos (kontrol.automatikaia.com/reembolsos).',
  ]],
  ['6. Cuenta pausada', [
    'Si la prueba o el plan vencen sin pago (con 3 días de gracia), la cuenta pasa a modo pausa: puedes entrar, ver tu información y pagar, pero no registrar ni modificar datos. Tu información no se borra por estar pausada.',
  ]],
  ['7. Uso permitido', [
    'Te comprometes a usar Kontrol solo para fines legales. No está permitido: vender productos o servicios ilegales; subir contenido que infrinja derechos de otros; intentar entrar a cuentas o datos ajenos; atacar, sobrecargar o copiar la plataforma; ni usarla para enviar spam.',
    'Podemos suspender o cerrar cuentas que incumplan estas reglas.',
  ]],
  ['8. Tu información y la de tus clientes', [
    'Los datos que registras (productos, ventas, clientes, fotos, etc.) son tuyos. Nos das permiso de guardarlos y procesarlos solo para darte el servicio.',
    'Si registras datos de tus clientes, eres responsable de tener su permiso para hacerlo y de usarlos de forma legal. Nosotros los tratamos por cuenta tuya y según nuestra Política de Privacidad.',
  ]],
  ['9. Catálogo público y enlaces', [
    'Si activas el catálogo, cotizaciones o enlaces públicos, la información que marques como visible (nombre del negocio, productos, precios, fotos y contacto) podrá verla cualquier persona que tenga el enlace.',
  ]],
  ['10. Funciones con inteligencia artificial', [
    'Algunas funciones (por ejemplo, mejorar fotos o generar descripciones) usan proveedores de inteligencia artificial. Los resultados pueden tener errores; revísalos antes de publicarlos. Eres responsable del contenido que publiques.',
    'Cada plan incluye una cantidad limitada de créditos de IA por mes.',
  ]],
  ['11. Disponibilidad', [
    'Trabajamos para que Kontrol funcione siempre, pero puede haber interrupciones por mantenimiento, fallas de internet o de nuestros proveedores. Te recomendamos descargar respaldos de tu información periódicamente.',
  ]],
  ['12. Responsabilidad', [
    'Kontrol se ofrece "tal como está". En la medida que permita la ley, no somos responsables por pérdidas indirectas, ganancias no obtenidas o decisiones de negocio tomadas con base en la información de la plataforma. Nuestra responsabilidad total no excederá lo que pagaste en los últimos 3 meses.',
    'Kontrol no sustituye la facturación fiscal autorizada por el SAR ni la asesoría de un contador.',
  ]],
  ['13. Propiedad intelectual', [
    'La plataforma, su diseño, código, marca Kontrol y marca Automatika.ia nos pertenecen. Tu plan te da permiso de usarla, no de copiarla, revenderla ni modificarla.',
  ]],
  ['14. Cancelación', [
    'Puedes cancelar tu plan cuando quieras, como se explica en la Política de Cancelación y Reembolsos. Tu cuenta quedará pausada al terminar el período pagado. Si quieres que eliminemos tu cuenta y tus datos, escríbenos.',
  ]],
  ['15. Cambios a estos Términos', [
    'Podemos actualizar estos Términos. Si el cambio es importante te avisaremos dentro de la app o por correo. Seguir usando Kontrol después del cambio significa que lo aceptas.',
  ]],
  ['16. Ley aplicable', [
    'Estos Términos se rigen por las leyes de la República de Honduras. Cualquier diferencia se intentará resolver primero de buena fe; si no es posible, se someterá a los tribunales competentes de Honduras.',
  ]],
];

const PRIVACIDAD = [
  ['1. Responsable', [
    `Automatika.ia, con domicilio en Olanchito, Yoro, Honduras, es responsable de los datos personales que se tratan en Kontrol. Contacto: ${CONTACTO}.`,
  ]],
  ['2. Qué datos recopilamos', [
    'De ti como usuario: correo electrónico, contraseña (guardada cifrada; nunca la vemos), nombre y datos de tu negocio (país, moneda, logo, teléfono, redes sociales), respuestas del formulario de bienvenida y la fecha en que aceptaste estos documentos.',
    'Datos de uso: qué secciones usas y cuándo, para mejorar la app. No vendemos esta información.',
    'Datos que tú registras de tu negocio: productos, fotos, ventas, gastos, clientes (nombre, teléfono, correo, dirección), cotizaciones, citas y órdenes. Estos datos son tuyos; nosotros solo los guardamos para darte el servicio.',
    'Datos de pedidos del catálogo: cuando alguien hace un pedido desde tu catálogo público, se guardan su nombre, teléfono y lo que pidió, para que tú lo atiendas.',
  ]],
  ['3. Para qué los usamos', [
    'Para crear y proteger tu cuenta, darte el servicio, administrar tu plan, enviarte avisos importantes, darte soporte, prevenir fraude y abuso, y mejorar Kontrol.',
    'No vendemos ni alquilamos tus datos ni los de tus clientes, y no los usamos para publicidad de terceros.',
  ]],
  ['4. Con quién los compartimos', [
    'Solo con proveedores que necesitamos para que Kontrol funcione, y solo lo necesario:',
    '• Supabase: base de datos, inicio de sesión y almacenamiento de fotos.',
    '• Vercel: alojamiento de la aplicación.',
    '• Cloudflare: protección contra robots (Turnstile) y dominio.',
    '• Proveedores de inteligencia artificial: solo cuando usas una función de IA, se envía la foto o el texto necesario.',
    '• Meta (Facebook/Instagram): solo si conectas tus redes para publicar desde Kontrol.',
    'Estos proveedores pueden estar fuera de Honduras (por ejemplo, en Estados Unidos). También podemos compartir datos si una autoridad competente lo exige conforme a la ley.',
  ]],
  ['5. Cómo los protegemos', [
    'Usamos conexión cifrada (HTTPS), contraseñas cifradas, verificación anti-robots y reglas en la base de datos para que cada negocio solo pueda ver su propia información. Ningún sistema es 100% seguro, pero revisamos la seguridad de forma periódica.',
  ]],
  ['6. Cuánto tiempo los guardamos', [
    'Mientras tu cuenta exista (activa o pausada). Puedes eliminar tu cuenta desde "Mi cuenta" dentro de Kontrol o como se explica en kontrol.automatikaia.com/eliminar-cuenta: la información de tu negocio se borra a los 30 días, salvo el registro de pagos que debemos conservar por obligación contable.',
  ]],
  ['7. Tus derechos', [
    'Puedes pedirnos acceder a tus datos, corregirlos, descargarlos, que dejemos de usarlos para algo específico o que los eliminemos. Escríbenos a la dirección de contacto y te responderemos lo antes posible.',
    'Si eres cliente de un negocio que usa Kontrol y quieres ejercer estos derechos, contacta primero a ese negocio, ya que es quien registró tus datos.',
  ]],
  ['8. Menores de edad', [
    'Kontrol no está dirigido a menores de 18 años y no recopilamos sus datos a sabiendas. Si crees que un menor creó una cuenta, escríbenos y la eliminaremos.',
  ]],
  ['9. Cookies y almacenamiento local', [
    'Usamos el almacenamiento del navegador solo para mantener tu sesión iniciada y recordar preferencias. Cloudflare Turnstile puede usar datos técnicos del navegador para distinguir personas de robots. No usamos cookies de publicidad.',
  ]],
  ['10. Cambios a esta política', [
    'Si cambiamos esta política de forma importante te avisaremos dentro de la app o por correo.',
  ]],
];

const REEMBOLSOS = [
  ['1. Resumen', [
    'Puedes cancelar tu plan de Kontrol en cualquier momento, sin penalidad. Al cancelar, no se te vuelve a cobrar y conservas el acceso hasta el final del período que ya pagaste. Tu información no se borra.',
  ]],
  ['2. Prueba gratis', [
    'Las cuentas nuevas tienen 14 días de prueba gratis sin pedir tarjeta. Si no eliges un plan al terminar la prueba, no se te cobra nada: la cuenta pasa a modo pausa y tus datos se conservan.',
  ]],
  ['3. Renovación automática', [
    'Si pagas con tarjeta, tu plan se renueva automáticamente al final de cada período (cada mes o cada año, según el ciclo que elegiste), con el mismo precio, hasta que lo canceles.',
    'Si pagas por transferencia, no hay renovación automática: te avisamos para que realices el siguiente pago.',
  ]],
  ['4. Cómo cancelar', [
    'Desde Kontrol: entra a "Mi plan" y toca "Cancelar mi plan". La cancelación queda hecha al momento y ahí mismo ves hasta qué fecha sigue activo tu plan. Si cambias de opinión antes de esa fecha, toca "Seguir con mi plan".',
    `También puedes escribirnos a ${CONTACTO} desde el correo de tu cuenta, indicando el nombre de tu negocio. Te confirmamos la cancelación en un máximo de 2 días hábiles.`,
    'Para que no se te cobre el siguiente período, cancela al menos 2 días antes de la fecha de renovación.',
  ]],
  ['5. Qué pasa después de cancelar', [
    'Sigues usando todas las funciones de tu plan hasta el último día del período pagado. Después, la cuenta pasa a modo pausa: puedes entrar y ver tu información, pero no registrar ni modificar datos.',
    'Puedes reactivar tu plan cuando quieras y encontrarás tu información tal como la dejaste. Si quieres que eliminemos tu cuenta y tus datos, pídelo por correo.',
    'Si tenías precio fundador y cancelas, al reactivar se aplica el precio vigente en ese momento.',
  ]],
  ['6. Reembolsos', [
    'Los pagos cubren un período por adelantado. Una vez iniciado el período, no se hacen reembolsos parciales por los días o meses que no uses, salvo en los casos siguientes o cuando la ley lo exija.',
    'Te devolvemos el 100% del monto en estos casos: (a) un cobro duplicado o hecho por error; (b) un cobro después de que solicitaste la cancelación a tiempo; (c) si Kontrol no estuvo disponible por causas nuestras durante más de 7 días seguidos dentro del período pagado.',
    'Plan anual: si es tu primer pago anual y lo solicitas dentro de los 7 días siguientes al cobro, te devolvemos el monto completo.',
  ]],
  ['7. Cómo solicitar un reembolso', [
    `Escríbenos a ${CONTACTO} con el nombre de tu negocio, la fecha y el monto del cobro. Respondemos en un máximo de 5 días hábiles.`,
    'Si el reembolso procede, se devuelve al mismo medio de pago. En pagos con tarjeta, el dinero puede tardar entre 5 y 15 días hábiles en verse en tu estado de cuenta, según tu banco.',
  ]],
  ['8. Cargos que no reconoces', [
    'Si ves un cargo de Kontrol que no reconoces, escríbenos antes de iniciar un reclamo con tu banco: lo revisamos y, si fue un error, lo devolvemos de inmediato.',
  ]],
  ['9. Cambios de plan', [
    'Puedes subir de plan cuando quieras: lo activamos de inmediato y el nuevo precio aplica desde tu siguiente cobro. Si bajas de plan, el cambio aplica en tu siguiente renovación.',
  ]],
];

const ELIMINAR = [
  ['1. Desde Kontrol (lo más rápido)', [
    'Entra a Kontrol con tu correo y contraseña, abre el menú y toca "Mi cuenta". Al final de la página toca "Eliminar mi cuenta", escribe ELIMINAR para confirmar y listo.',
  ]],
  ['2. Si no puedes entrar a Kontrol', [
    `Escríbenos a ${CONTACTO} desde el correo con el que creaste tu cuenta, con el asunto "Eliminar mi cuenta" y el nombre de tu negocio. Te confirmamos por correo en un máximo de 5 días hábiles.`,
  ]],
  ['3. Qué se elimina', [
    'Si eres la dueña del negocio: tu usuario, tu negocio y toda su información (productos, fotos, ventas, gastos, clientes, servicios, cotizaciones, citas, órdenes, pedidos y reportes) y los usuarios de tu equipo.',
    'Si eres parte del equipo de un negocio (vendedor/a): tu usuario y tu acceso. Las ventas que registraste se quedan en el negocio, porque son información de la dueña.',
  ]],
  ['4. Cuándo se elimina', [
    `Dueña: tu cuenta queda en pausa desde que lo solicitas y se elimina definitivamente a los ${30} días. En ese tiempo puedes cancelar desde "Mi cuenta" y todo sigue igual. Te recomendamos descargar tus reportes antes.`,
    'Equipo: tu usuario se elimina al momento.',
  ]],
  ['5. Qué conservamos', [
    'Solo el registro de los pagos de tu plan (fecha, monto y plan), sin los datos de tu negocio, porque la ley nos obliga a guardar la información contable. Las copias de seguridad técnicas se borran solas en su ciclo normal.',
  ]],
];

const DOCS = {
  terminos: { titulo: 'Términos y Condiciones', secciones: TERMINOS },
  privacidad: { titulo: 'Política de Privacidad', secciones: PRIVACIDAD },
  reembolsos: { titulo: 'Política de Cancelación y Reembolsos', secciones: REEMBOLSOS },
  'eliminar-cuenta': { titulo: 'Eliminar tu cuenta de Kontrol', secciones: ELIMINAR },
};
const ENLACES = [['/terminos', 'Términos y Condiciones'], ['/privacidad', 'Política de Privacidad'], ['/reembolsos', 'Cancelación y Reembolsos'], ['/eliminar-cuenta', 'Eliminar tu cuenta']];

export default function LegalView({ doc }) {
  const { titulo, secciones } = DOCS[doc] || DOCS.terminos;
  const otros = ENLACES.filter(([ruta]) => ruta !== `/${doc}`);
  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#FDF2F8', padding: '24px 16px', fontFamily: 'Arial, sans-serif', boxSizing: 'border-box' }}>
      <div style={{ maxWidth: '760px', margin: '0 auto', backgroundColor: 'white', borderRadius: '16px', padding: '28px 24px', boxShadow: '0 8px 30px rgba(109,40,217,0.10)', boxSizing: 'border-box', color: '#374151', lineHeight: 1.6 }}>
        <a href="/" style={{ color: '#6D28D9', fontSize: '13px', textDecoration: 'none', fontWeight: 'bold' }}>← Volver a Kontrol</a>
        <h1 style={{ margin: '16px 0 4px', fontSize: '24px', color: '#1C1830' }}>{titulo}</h1>
        <p style={{ margin: '0 0 20px', fontSize: '13px', color: '#9CA3AF' }}>Kontrol by Automatika.ia · Última actualización: {FECHA}</p>
        {secciones.map(([t, parrafos]) => (
          <section key={t} style={{ marginBottom: '18px' }}>
            <h2 style={{ margin: '0 0 6px', fontSize: '16px', color: '#6D28D9' }}>{t}</h2>
            {parrafos.map((p) => <p key={p} style={{ margin: '0 0 8px', fontSize: '14px' }}>{p}</p>)}
          </section>
        ))}
        <div style={{ margin: '24px 0 0', fontSize: '13px', borderTop: '1px solid #F3E8FF', paddingTop: '16px', display: 'grid', gap: '6px' }}>
          <p style={{ margin: 0 }}><b>Contacto:</b> Automatika.ia · Olanchito, Yoro, Honduras · {CONTACTO}</p>
          <p style={{ margin: 0 }}>Ver también: {otros.map(([ruta, nombre], i) => (
            <span key={ruta}>{i > 0 && ' · '}<a href={ruta} style={{ color: '#6D28D9' }}>{nombre}</a></span>
          ))}</p>
        </div>
      </div>
    </div>
  );
}
